"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.latinAmericaTranslations = void 0;
var _types = require("../../../types");
const latinAmericaTranslations = exports.latinAmericaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: '¡Lo sentimos!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Volver',
  [_types.ErrorPageTranslationKey.text]: 'Esta página está fuera de servicio en este momento.',
  [_types.ErrorPageTranslationKey.notFound]: 'La página que intentas ver no existe',
  [_types.ErrorPageTranslationKey.unauthorized]: 'La página a la que estás intentando entrar es restringida y no se cumplen todos los criterios.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Comuníquese con el equipo de soporte de Oriflame por correo electrónico:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: '¡La URL solicitada fue rechazada!'
};
